export enum TransactionStatus {
    Pending = 'pending',
    InProgress = 'in-progress',
    Done = 'done',
    Failed = 'failed',
    Canceled = 'canceled',
    Initiated = 'initiated',
}
